export default __webpack_public_path__ + "static/media/3-4.d1d80f15.jpg";